import { useState } from "react";
import * as uuid from "uuid";
import { MaterialImageSchema } from "../add-plant-material-form/material-image-schema";
import { type StagedImage } from "./add-material-photos-button";

export const useStagedMaterialPhotos = (
  initialValue?: Array<MaterialImageSchema> | null,
) => {
  const [uploadsInProgressDialogOpen, setUploadsInProgressDialogOpen] =
    useState(false);
  const [stagedPhotos, setStagedPhotos] = useState<Array<StagedImage>>(
    initialValue?.map((props) => ({
      ...props,
      id: uuid.v4(),
      thumb: props.assetUrl,
      complete: true,
    })) ?? [],
  );

  const processStagedPhotos = () => {
    if (!uploadsInProgressDialogOpen && stagedPhotos.some((i) => !i.complete)) {
      setUploadsInProgressDialogOpen(true);
      return;
    }
    return stagedPhotos
      .filter((i): i is typeof i & { assetUrl: string } => i.assetUrl != null)
      .filter((i) => i.complete)
      .map(({ assetUrl, description, capturedAt, capturedBy }) => ({
        assetUrl,
        description,
        capturedBy,
        capturedAt,
      }));
  };

  return {
    stagedPhotos,
    setStagedPhotos,
    uploadsInProgressDialogOpen,
    setUploadsInProgressDialogOpen,
    processStagedPhotos,
  };
};
